<template>
    <detalhe titulo="Status" :size="size">
        <status :status="participante?.statusPresencaEventoDescr"></status>
    </detalhe>
    <detalhe titulo="Dias Ausência" :size="size">
        {{ participante?.diasAusencia }}
    </detalhe>
    <detalhe titulo="Objeto Integração" :size="size">
        <vue-json-pretty
            :data="JSON.parse(participante?.objetoIntegracaoDiasAusencia)"
            :showDoubleQuotes="true"
            v-if="participante?.objetoIntegracaoDiasAusencia && participante?.objetoIntegracaoDiasAusencia?.isJson()"
        ></vue-json-pretty>
        <span v-if="participante?.objetoIntegracaoDiasAusencia && !participante?.objetoIntegracaoDiasAusencia?.isJson()">{{
            participante?.objetoIntegracaoDiasAusencia
        }}</span>
    </detalhe>
    <detalhe titulo="Retorno Integração" :size="size">
        <vue-json-pretty
            :data="JSON.parse(participante?.retornoIntegracaoDiasAusencia)"
            :showDoubleQuotes="true"
            v-if="participante?.retornoIntegracaoDiasAusencia && participante?.retornoIntegracaoDiasAusencia?.isJson()"
        ></vue-json-pretty>
        <span v-if="participante?.retornoIntegracaoDiasAusencia && !participante?.retornoIntegracaoDiasAusencia?.isJson()">
            {{ participante?.retornoIntegracaoDiasAusencia }}</span
        >
    </detalhe>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

export default {
    components: {
        VueJsonPretty,
    },

    props: {
        participante: {
            type: Object,
        },
    },

    data() {
        return {
            size: '140',
        };
    },
};
</script>
